/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemsCostQueryResult } from '../../models/get-project-items-cost-query-result';

export interface ApiProjectItemGetProjectItemsCostGet$Plain$Params {
  ProjectId: string;
}

export function apiProjectItemGetProjectItemsCostGet$Plain(http: HttpClient, rootUrl: string, params: ApiProjectItemGetProjectItemsCostGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsCostQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemGetProjectItemsCostGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemsCostQueryResult>;
    })
  );
}

apiProjectItemGetProjectItemsCostGet$Plain.PATH = '/api/ProjectItem/GetProjectItemsCost';
